import React, { useState, useEffect } from "react";
import { POST } from "Common/api";
import { API_RATING_SETRATING } from "lib/endpoints/rating";
import withLanguageContext from "lib/hocs/withLanguageContext";
import LangContext from "./langContext";
import RatingForm from "./ratingForm";
import { StyledNoOfRatings } from "./style";
import { Rating as MuiRating } from "Components/Base/Inputs/Rating";
import BaseGrid from "Components/Fragment/BaseGrid";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../../themes/theme";
import { Box } from "Components/Base/Layout/Box";
import { Tooltip } from "Components/Base/DataDisplay/Tooltip";
import Dialog from "Components/Fragment/Dialog";

const Rating = (props) => {
  const {
    languageContext,
    type,
    objectId,
    currentRating,
    currentComment,
    updateRating,
    readOnly,
    noOfRatings,
    managerView,
  } = props;
  const [rating, setRating] = useState(currentRating || 0);
  const [ratingActive, setRatingActive] = useState(false);

  const changeRating = () => {
    setRatingActive(true);
  };

  const closeRatingForm = () => {
    setRatingActive(false);
  };

  const saveRating = async (newRating, comment) => {
    if (!comment) comment = "";

    await POST(
      `${API_RATING_SETRATING}?${new URLSearchParams({
        type,
        objectId,
        rating: newRating,
        comment,
        anonymous: false,
      })}`,
    );
    if (updateRating) {
      updateRating(newRating, comment, objectId);
    }
    setRating(newRating);
    closeRatingForm();
  };

  useEffect(() => {
    setRating(currentRating || 0);
  }, [currentRating]);

  const isAverageRating = noOfRatings > 0 && readOnly;
  const isReadOnly = isAverageRating || managerView;

  return (
    <LangContext.Provider value={languageContext}>
      <ThemeProvider theme={theme}>
        <BaseGrid childWidth="auto" spacing={1}>
          {isReadOnly && <MuiRating value={rating} size="small" readOnly />}
          {!isReadOnly && (
            <Tooltip title={languageContext("addreview")} placement="top">
              <Box onClick={changeRating} sx={{ cursor: "pointer" }}>
                <MuiRating value={rating} size="small" readOnly />
              </Box>
            </Tooltip>
          )}
          {isAverageRating && (
            <StyledNoOfRatings>({noOfRatings})</StyledNoOfRatings>
          )}
        </BaseGrid>
        {ratingActive && (
          <Dialog
            open={true}
            onClose={closeRatingForm}
            title={languageContext("rate")}
            maxWidth="lg"
            text={
              <RatingForm
                tempRating={rating}
                tempComment={currentComment}
                saveRating={saveRating}
                closeRatingForm={closeRatingForm}
              />
            }
          />
        )}
      </ThemeProvider>
    </LangContext.Provider>
  );
};

export default withLanguageContext(Rating, "Rating");
